import { OpenAPI, RisksService } from "./api/generated";
import { request as apiRequest } from "./api/generated/core/request";
import { withApiData } from "./api/openapiClient";
import apiClient from "./api/apiClient";
import { listRiskCategories } from "./api/riskCategories.api";

export const getRisks = (params = {}) =>
  withApiData(
    RisksService.listRisksRisksGet({
      owner: params.owner,
      category: params.category,
      status: params.status,
      overdueReview: params.overdue_review ?? params.overdueReview,
      overdueTreatment: params.overdue_treatment ?? params.overdueTreatment,
      treatmentStatus: params.treatment_status ?? params.treatmentStatus,
      appetiteBreach: params.appetite_breach ?? params.appetiteBreach,
      riskType: params.risk_type || params.riskType,
      limit: params.limit,
      offset: params.offset,
      sort: params.sort,
      q: params.q,
    })
  );

export const getRiskCategories = (params = {}) => listRiskCategories(params);

export const getRiskById = (id) =>
  withApiData(
    RisksService.getRiskEndpointRisksRiskIdGet({
      riskId: Number(id),
      includeActions: false,
      includeControls: false,
    })
  );

export const createRisk = (data) =>
  withApiData(
    RisksService.createRiskEndpointRisksPost({
      requestBody: data,
    })
  );

export const updateRisk = (id, data) =>
  withApiData(
    RisksService.updateRiskEndpointRisksRiskIdPut({
      riskId: Number(id),
      requestBody: data,
    })
  );

export const updateRiskParent = (id, parentId) =>
  withApiData(
    RisksService.updateRiskEndpointRisksRiskIdPut({
      riskId: Number(id),
      requestBody: { parent_id: parentId === null ? null : Number(parentId) },
    })
  );

export const deleteRisk = (id, confirmationText, reason) =>
  withApiData(
    apiRequest(OpenAPI, {
      method: "DELETE",
      url: "/risks/{risk_id}",
      path: { risk_id: Number(id) },
      query: {
        ...(confirmationText ? { confirmation_text: confirmationText } : {}),
        ...(reason ? { reason } : {}),
        hard: true,
      },
    })
  );

export const archiveRisk = (id, reason) =>
  withApiData(
    apiRequest(OpenAPI, {
      method: "DELETE",
      url: "/risks/{risk_id}",
      path: { risk_id: Number(id) },
      query: reason ? { reason } : undefined,
    })
  );

export const restoreRisk = (id, reason) =>
  withApiData(
    apiRequest(OpenAPI, {
      method: "POST",
      url: "/risks/{risk_id}/restore",
      path: { risk_id: Number(id) },
      query: reason ? { reason } : undefined,
    })
  );

export const reviewRisk = (id, payload) =>
  withApiData(
    apiRequest(OpenAPI, {
      method: "POST",
      url: "/risks/{risk_id}/review",
      path: { risk_id: Number(id) },
      body: payload,
      mediaType: "application/json",
    })
  );

export const getRiskHistory = (id) =>
  withApiData(
    RisksService.getRiskHistoryRisksRiskIdHistoryGet({
      riskId: Number(id),
    })
  );

export const exportRiskPdf = (id, payload) =>
  apiClient.post(`/risks/${Number(id)}/export/pdf`, payload, {
    responseType: "blob",
  });

export const getRiskSnapshots = () => withApiData(apiRequest(OpenAPI, { method: "GET", url: "/risk-snapshots" }));
export const createRiskSnapshot = (payload) =>
  withApiData(
    apiRequest(OpenAPI, { method: "POST", url: "/risk-snapshots", body: payload, mediaType: "application/json" })
  );
export const getRiskSnapshot = (id) =>
  withApiData(apiRequest(OpenAPI, { method: "GET", url: "/risk-snapshots/{id}", path: { id: Number(id) } }));
export const exportRiskSnapshot = (id) =>
  apiRequest(OpenAPI, {
    method: "GET",
    url: "/risk-snapshots/{id}/export",
    path: { id: Number(id) },
    responseType: "blob",
  });

export const downloadRiskBulkUploadTemplate = () =>
  apiClient
    .get("/risks/bulk-upload/template", {
      responseType: "blob",
    })
    .then((response) => response.data);

export const importRiskBulkUploadWorkbook = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await apiClient.post("/risks/bulk-upload/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const getRiskHeatmap = (view = "residual") =>
  withApiData(
    apiRequest(OpenAPI, {
      method: "GET",
      url: "/risk-dashboard/heatmap",
      query: view ? { view } : undefined,
    })
  );
